import Component from './component';
import { SpotifyErrorCodes } from './component';
export { SpotifyErrorCodes };
export default Component;
